import { useTranslation } from 'react-i18next';

import { normalizeRichTextWhitespace } from '@utils/helpers';

import {
    CompanyPoliciesContent,
    CompanyPoliciesTitle,
    CompanyPoliciesWrapper,
} from './CompanyPolicies.styled';

interface CompanyPoliciesProps {
    policiesContent: string;
}

export const CompanyPolicies = ({ policiesContent }: CompanyPoliciesProps) => {
    const { t } = useTranslation();

    return (
        <CompanyPoliciesWrapper>
            <CompanyPoliciesTitle>{t('MY_POLICIES_TEXT')}</CompanyPoliciesTitle>
            {policiesContent && (
                <CompanyPoliciesContent
                    className={'ql-editor'}
                    dangerouslySetInnerHTML={{
                        __html: normalizeRichTextWhitespace(policiesContent),
                    }}
                />
            )}
        </CompanyPoliciesWrapper>
    );
};
